import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import DashTabs from "./DashTabs";
import DashTable from "./DashTable";
import CustomerDetails from "./CustomerDetails";
import {  Container } from "react-bootstrap";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import { useGetBranchQuery } from "../../../Service/branches";
import Toast from "../../../Component/DigitalMarketing/Toast";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import Button from "@mui/material/Button";

export const intialBranch = {
  branchName: "",
  isMainBranch: 0,
  address: "",
  city: "",
  state: "",
  country: "",
  pincode: "",
  emailId: "",
  mobileNo: "",
  activeStatus: 1,
};
function Branch() {
  const [show, setshow] = useState(false);
  const [branchDetail, setBranchDetail] = useState(intialBranch);
  const dispatch = useDispatch<any>();
  const [searchValue, setSearchValue] = useState("");
  const [branchList, setBranchList] = useState([]);
  const { data: branches, refetch } = useGetBranchQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const { open, message, openSnackBar, type } = useSnackbar();

  const onChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    if (!searchValue.length) setBranchList(branches);
    else filterBranches(branches);
  }, [branches]);

  useEffect(() => {
    filterBranches(branchList);
  }, [searchValue]);

  const filterBranches = (branchList) => {
    let filterList = branchList.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toUpperCase().includes(searchValue.toUpperCase())
      )
    );
    if (searchValue == "") {
      setBranchList(branches);
    } else setBranchList(filterList);
  };

  useEffect(() => {
    const data: any = {
      first: "Branches",
    };
    dispatch(Change(data));
    
  }, [dispatch]);

  return (
    <React.Fragment>
      <Toast open={open} type={type} message={message} />

      <Container fluid>
        <div className="d-flex">
          <SearchBox
            value={searchValue}
            onChange={(event) => onChangeSearch(event)}
          />
        </div>
        <div>
          <DashTabs
            show={show}
            setshow={setshow}
            setBranchDetail={setBranchDetail}
          />
        </div>
        <div className="grid-container">
          <div className={show ? "item1" : "item1-full"}>
            <DashTable
              show={show}
              setshow={setshow}
              branchDetail={branchDetail}
              branches={branchList}
              setBranchDetail={setBranchDetail}
            />
          </div>
          {show ? (
            <div className="Customer-details mx-3 item2">
              <ul className="md-bord">
                <CustomerDetails
                  openSnackBar={openSnackBar}
                  cancel={
                    <Button
                      variant="contained"
                      id="btn-cancel"
                      className="me-2"
                      onClick={() => {
                        setshow(!show);
                        setBranchDetail(intialBranch);
                      }}
                    >
                      Cancel
                    </Button>
                  }
                  branchDetail={branchDetail}
                  setBranchDetail={setBranchDetail}
                  setshow={setshow}
                  show={show}
                />
              </ul>
            </div>
          ) : (
            ""
          )}
        </div>
      </Container>
    </React.Fragment>
  );
}

export default React.memo(Branch);
